import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';

const guard = buildGuards(hasFlagEnabled('metricsManagerInCompanyProfile'));

export const Route = createFileRoute(
  '/_secured/company-profile/metrics-manager',
)({
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );

    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/mdm-hub');

    const title = i18n.t('Metrics Manager | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
